import {Locale, useConfig} from '@aboutyou/config';
import {useIsFeatureActive} from '@aboutyou/feature-flags';
import {Redirect} from '@aboutyou/router';
import React from 'react';
import {useLocation} from 'react-router';

const redirectPaths = [
  '/kolofon',
  '/personvernretningslinjer',
  '/cp/takk-norway-116145',
  '/cp/takk-norway-106121',
];

export const useShopExitRedirect = () => {
  const {isActive} = useIsFeatureActive('enable_country_exit');
  const {isActive: isV2Active} = useIsFeatureActive('enable_country_exit_v2');

  const {locale, environment} = useConfig();
  const customPageId = environment === 'production' ? '106121' : '116145';
  const globalShopUrlV2 = `https://www.aboutyou${
    environment !== 'production' ? '-staging' : ''
  }.com`;
  const globalShopUrl = `https://www.aboutyou${
    environment !== 'production' ? '-staging' : ''
  }.com/cp/see-you-global-${customPageId}?force-global=1&force-language=1`;

  if (isV2Active) {
    if (
      locale === Locale.he_IL ||
      locale === Locale.en_IL ||
      locale === Locale.ar_SA ||
      locale === Locale.en_SA
    ) {
      return {
        isActive: isV2Active,
        redirect: (
          <Redirect
            to={`${globalShopUrlV2}?force-global=1&force-language=1`}
            keepSearch={false}
            statusCode={301}
          />
        ),
      };
    }

    if (locale === Locale.no_NO || locale === Locale.en_IE) {
      return {
        isActive: isV2Active,
        redirect: (
          <Redirect
            to={`${globalShopUrlV2}/h?force-global=1&force-language=1`}
            keepSearch={false}
            statusCode={301}
          />
        ),
      };
    }
  }

  if (isActive) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const location = useLocation();
    if (!redirectPaths.includes(location.pathname)) {
      return {
        isActive,
        redirect: (
          <Redirect
            to={
              locale === 'no_NO'
                ? `/cp/takk-norway-${customPageId}`
                : globalShopUrl
            }
            keepSearch={false}
            statusCode={301}
          />
        ),
      };
    }
  }

  return {isActive, redirect: null};
};
